import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=9b554a86&"
import script from "./DefaultView.vue?vue&type=script&lang=ts&"
export * from "./DefaultView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports